export default __webpack_public_path__ + "static/media/profileComplete.911857e5.png";